define.alias("ember-power-select/helpers/ember-power-select-is-equal", "settings/helpers/ember-power-select-is-equal");